const CustomComponentConfigs = masterData => {
  return {
    ServiceAdministratorClient: {
      nameKey: 'clientName',
      valueKey: 'id',
      apiPath: 'service-administrator-clients',
      searchKey: 'clientName',
      control: 'autocomplete',
      autoDisplayIfOneValue: true,
    },
    ServiceAdministrator: {
      nameKey: 'serviceAdministratorName',
      valueKey: 'id',
      apiPath: 'service-administrators',
      searchKey: 'serviceAdministratorName',
      control: 'autocomplete',
    },
    BrandsAll: {
      nameKey: 'brandName',
      valueKey: 'id',
      apiPath: 'brands',
      searchKey: 'brandName',
      control: 'autocompletev2',
    },
    ProductLineAll: {
      nameKey: 'productLineName',
      valueKey: 'id',
      apiPath: 'service-administrator-product-lines',
      searchKey: 'productLineName',
      control: 'autocomplete',
    },
    Industry: {
      nameKey: 'industryName',
      valueKey: 'id',
      apiPath: 'industries',
      searchKey: 'industryName',
      control: 'autocomplete',
    },
    RateCardSelector: {
      nameKey: 'name',
      valueKey: 'id',
      apiPath: 'labor-matrices',
      searchKey: 'name',
      control: 'autocomplete',
    },
    ServiceJobForm: {
      nameKey: 'formName',
      valueKey: 'id',
      apiPath: 'service-job-forms',
      searchKey: 'formName',
      control: 'autocomplete',
    },
    ServiceProvider: {
      nameKey: 'name',
      valueKey: 'id',
      apiPath: 'service-providers',
      searchKey: 'name',
      control: 'autocompletev2',
    },
    PurchasedFrom: {
      nameKey: 'name',
      valueKey: 'id',
      apiPath:
        'service-providers?status=$eq:ACTIVE&serviceProviderType.typeCode=$eq:SSD',
      searchKey: 'name',
      control: 'autocompletev2',
    },
    ServiceSite: {
      nameKey: 'serviceSiteName',
      valueKey: 'id',
      apiPath: 'service-sites',
      searchKey: 'serviceSiteName',
      control: 'autocomplete',
    },
    ServiceType: {
      nameKey: 'serviceType',
      valueKey: 'id',
      apiPath: 'service-administrator-service-types',
      searchKey: 'serviceType',
      control: 'autocomplete',
    },
    WarrantyType: {
      nameKey: 'warrantyType',
      valueKey: 'id',
      apiPath: 'service-administrator-warranty-types',
      searchKey: 'warrantyType',
      control: 'autocomplete',
    },
    YesNo: {
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      control: 'SelectStatic',
    },
    ActiveInActiveEnum: {
      options: [
        { label: 'Active', value: 'ACTIVE' },
        { label: 'In-Active', value: 'INACTIVE' },
      ],
      control: 'SelectStatic',
    },
    ActiveInactiveDeleted: {
      options: [
        { label: 'Active', value: 'ACTIVE' },
        { label: 'In-Active', value: 'INACTIVE' },
        { label: 'Deleted', value: 'DELETED' },
      ],
      control: 'SelectStatic',
    },
    ActiveInActiveStatus: {
      options: [
        { label: 'Active', value: true },
        { label: 'In-Active', value: false },
      ],
      control: 'SelectStatic',
    },
    CompanyType: {
      options: masterData.companyTypes,
      control: 'SelectStatic',
    },
    ServiceProviderAddressType: {
      options: masterData.addressTypes,
      control: 'SelectStatic',
    },
    ServiceProviderContactType: {
      options: masterData.contactTypes,
      control: 'SelectStatic',
    },
    ServiceProviderTypes: {
      nameKey: 'typeName',
      valueKey: 'id',
      apiPath: 'service-provider-types?status=$eq:ACTIVE',
      searchKey: 'typeName',
      control: 'autocompletev2',
    },
    States: {
      nameKey: 'name',
      valueKey: 'id',
      control: 'StatesSelector',
    },
    ContractorComplianceStatus: {
      options: masterData.contractorComplianceStatus,
      control: 'SelectStatic',
    },
    DispatchMethods: {
      options: masterData.dispatchMethods,
      control: 'SelectStatic',
    },
    RepairSeverity: {
      nameKey: 'repairCategory',
      valueKey: 'id',
      apiPath: 'service-administrator-repair-categories',
      searchKey: 'repairCategory',
      control: 'autocomplete',
    },
    /** Insight config name options from masterData (GET /sxcl/v1/config); fallback for older API */
    InsightConfigName: {
      options: masterData.insightConfigName,
      control: 'SelectStatic',
    },
    /** Insight config value types from masterData (GET /sxcl/v1/config); fallback for older API */
    InsightConfigValue: {
      control: 'InsightConfigValue',
      types: masterData.insightConfigValue,
    },
  };
};

export default CustomComponentConfigs;
